module.exports = __webpack_public_path__ + "img/logo_trade_quadrado.8bdd8688.png";